<template lang="pug">
  r-table(
    loading-text="Cargando pagos del proveedor..."
    no-data-text="Sin pagos del proveedor."
    no-actions
    no-search
    no-remove
    ref="table"
    v-bind="tableProps"
    @detail="submitShow"
    )
    //dialog-invoice-detail(
      :invoice-id="invoiceId"
      ref="dialog"
      )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import ProviderPaymentService from '@/services/api/purchase/PchProviderPayment'
  import ProviderPaymentHeaders from '@/views/Purchase/PchProviderPayment/PchProviderPaymentHeaders'
  //
  export default {
    name: 'provider-payment-list',
    components: {
      RTable,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableProps() {
        return {
          service: new ProviderPaymentService().toList(),
          headers: ProviderPaymentHeaders,
          filters: [],
          paramFilter: {
            pch_provider_id: this.$route.params.id,
          },
        }
      },
    },
    data() {
      return {
        selected: null,
      }
    },
  }
</script>
